import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Box,
  Text,
  ChakraProvider,
  extendTheme,
} from '@chakra-ui/react'
import { CheckArrowSvg } from '../../../../../assets/svgs'

const ContactUsModel = ({ onClick, isOpen }) => {
  const theme = extendTheme({
    components: {
      Modal: {
        baseStyle: (props) => ({
          dialog: {
            maxWidth: ['758px', '758px', '758px'],
            minWidth: '758px',
            maxHeight: '100%',
            minHeight: '350px',
            // bg: '#00ff00',
          },
        }),
      },
    },
  })

  return (
    <>
      <ChakraProvider theme={theme}>
        <Modal
          isOpen={isOpen}
          onClose={() => onClick(false)}
          size={'xl'}
          preserveScrollBarGap="appendToParentPortal"
        >
          <ModalOverlay />

          <ModalContent
            display="flex"
            flexFlow="column"
            justifyContent="center"
            alignItems="center"
          >
            <ModalHeader>
              <CheckArrowSvg />
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody
              display="flex"
              flexFlow="column"
              //   justifyContent="flex-start"
            >
              <Box
                display="flex"
                flexFlow="column"
                justifyContent="center"
                alignItems="center"
              >
                <Text
                  fontSize="48px"
                  lineHeight="50px"
                  color="#83B53C"
                  fontWeight="bold"
                  marginBottom="20px"
                  textAlign="center"
                >
                  Thanks for submitting your response
                </Text>
                <Text fontSize="24px" color="#979797" textAlign="center">
                  One of our agent will get in touch with you soon
                </Text>
              </Box>
            </ModalBody>
          </ModalContent>
        </Modal>
      </ChakraProvider>
    </>
  )
}

export default ContactUsModel
